import { render, staticRenderFns } from "./Listpeserta.vue?vue&type=template&id=0098cad0"
import script from "./Listpeserta.vue?vue&type=script&lang=js"
export * from "./Listpeserta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports